'use strict'

function getXPclnHeaders(req) {
  const headers = (req && req.headers) || {}
  return Object.keys(headers)
    .filter((header) => header.indexOf('x-pcln-') > -1)
    .reduce((a, v) => {
      a[v] = headers[v]
      return a
    }, {})
}

module.exports = getXPclnHeaders
